export default api => ({
    list: () => api.get('/sources'),
})
